import { render, staticRenderFns } from "./CreateShippingModal.vue?vue&type=template&id=b55937a8"
import script from "./CreateShippingModal.vue?vue&type=script&lang=js"
export * from "./CreateShippingModal.vue?vue&type=script&lang=js"
import style0 from "./CreateShippingModal.vue?vue&type=style&index=0&id=b55937a8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports